import { RouteItem } from '@eastcoal/router/types/route'

import { NEWS_DETAIL_PAGE_PATH, NEWS_LIST_PAGE_PATH } from './constants/path'

export const newsListRoute: RouteItem = {
  title: '行业资讯',
  hideInMenu: true,
  children: [
    {
      title: '列表',
      path: NEWS_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '详情',
      path: NEWS_DETAIL_PAGE_PATH,
      Component: () => import('./Detail/index')
    }
  ]
}
